import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function AddCategoryPopup({topic, setPopup}) {
    const [catgryInfo, setCatgryInfo] = useState({});
    const [categoryList, setCategoryList] = useState([]);

    useEffect( ()  => { 
      async function fetchData() {       
       const category = await axios.get(`https://ahlehaqserver.herokuapp.com/api/category/${topic}`)
       setCategoryList(category.data.response);
      }
      fetchData();
    },[])

    const saveCategory = async (e) => {
         e.preventDefault();

         try {
           if(categoryList.find(data => data.category === catgryInfo.category)){
            toast.error("This category is already in the list");
           }else{
             const insertCategory = await axios.post('https://ahlehaqserver.herokuapp.com/api/category', catgryInfo);
         
            if(insertCategory.data.code === 200){
               setPopup(false);
               toast.success("Category added successfully!");
            }
           }
         
         }catch{

         }
    }
    return (
        <div>
            <form onSubmit={saveCategory}>
                <div className="row">
                
                     <div className={topic === "Boyan"? "col-md-6" : "col-md-12"}>
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                            Write category name<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded"
                              placeholder="Write category name"
                              id="exampleInputPassword1"
                              name="category"
                              value={catgryInfo?.category || ""}
                              required
                              onChange={(e) =>
                                setCatgryInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                  "topic": topic,
                                }))
                              }
                            />
                          </div>
                       </div>

                       {
                           topic === "Boyan" &&  
                           <div className="col-md-6">
                           <div className="form-group">
                               <label for="exampleInputEmail1" className="font-weight-bold">
                                 Select Language<span className="text-danger">*</span>
                               </label>
                               
                               <select
                                 className="form-control rounded"
                                 id="exampleInputEmail1"
                                 name="bangla"
                                 value={catgryInfo?.bangla || ""}
                                 required
                                 onChange={(e) =>
                                     setCatgryInfo((prev) => ({
                                     ...prev,
                                     [e.target.name]: e.target.value,
                                   }))
                                 }
                               >
                                 <option>
                                   Select Boyan Language
                                 </option>
                                     <option value="true">
                                       Bangla
                                     </option>
                                     <option value="false">
                                       Urdu
                                     </option>
                               </select>  
                           </div>
                         </div>
                       }


                       <div className="col-md-12">
                            <div className=" d-flex">
                                    <button
                                        type="submit"
                                        className="btn btn-success rounded px-4 ml-auto"
                                    >
                                        Done
                                    </button>

                                    <button
                                        className="btn btn-danger ml-2"
                                        onClick={() => setPopup(false)}
                                    >
                                        Close
                                    </button>
                                </div>
                       </div>
                      
                </div>
            </form>
        </div>
    )
}
